import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import InstallPrompt from './components/InstallPrompt';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Achievements from './pages/Achievements';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import { trackPageView } from './utils/analytics';
import './App.css';

// Component to track page views
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);
  
  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <PageTracker />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <InstallPrompt />
      </div>
    </Router>
  );
}

export default App;
